import React from 'react';
import PropTypes from 'prop-types';

import './view.scss';

export const BadgesView = ({ filters, setFilter }) => (
    Object.entries(filters).map(([key, value], firstIndex) => {
        // [key, value] contains filter name and filter values. Door types filter name is 'type', and we want to exclude it
        const excludedFilter = 'type';

        if (key !== excludedFilter) {
            return (
                (((typeof value) === 'string') && value.length)
                    ? (
                        <button
                            className="badge"
                            type="button"
                            key={ firstIndex }
                            onClick={ () => {
                                setFilter('unset', key, value);
                            } }
                        >
                            { value }
                        </button>
                    )
                    : (
                        [...value].map((currentValue, index) => (
                            <button
                                className="badge"
                                type="button"
                                key={ index }
                                onClick={ () => {
                                    setFilter('unset', key, currentValue);
                                } }
                            >
                                { currentValue }
                            </button>
                        ))
                    )
            );
        }

        return '';
    })
);

BadgesView.propTypes = {
    filters: PropTypes.instanceOf(Object).isRequired,
    setFilter: PropTypes.func.isRequired
};